export enum ActivityManageScreen {
  ActivityEdit = "activity-edit",
  ProgressStatus = "progress-status",
  CreateBatch = "create-batch",
  ConfirmDelete = "confirm-delete",
  EditDetails = "edit-details",
  EditAttribute = "edit-attribute",
}

export interface ActivityEditProps {
  onScreenChange: (screen: ActivityManageScreen) => void
  onBack: () => void
  onChange: () => void
  onClose: () => void
}
